/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_VoiceInputs */



/**
* | output |
* | --- |
* | "Voice" |
*
* @param {Editor_Table_Column_VoiceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_voice = /** @type {((inputs?: Editor_Table_Column_VoiceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_VoiceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voix")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stimme")
	if (locale === "it") return /** @type {LocalizedString} */ ("Voce")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Голос")
	if (locale === "es") return /** @type {LocalizedString} */ ("Voz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嗓音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("声")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आवाज़")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Voz")
	return /** @type {LocalizedString} */ ("Voice")
});